import AttendanceConsoleRepository from './attendanceConsoleRepository'
import InsightsRepository from './insightsRepository'
import SettingsRepository from './settingsRepository'

export default {
  attendanceConsole: AttendanceConsoleRepository,
  insights: InsightsRepository,
  settings: SettingsRepository
}
